import { Component } from '@angular/core';
import { IonNav, ModalController } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';
import { IssueDetails, IssueOptions } from '@usf/list-types';
import { ServiceRequestService } from '@service-request/services/service-request.service';

@Component({
  template: '',
})
export class IssueAndIssueDetailsBaseComponent {
  constructor(
    protected nav: IonNav,
    private modalController: ModalController,
    readonly platformService: PlatformService,
    protected serviceRequestService: ServiceRequestService,
  ) {}

  async getIssueDetails(selectedIssue: IssueOptions) {
    this.serviceRequestService.setModalIssueAndDetails(
      selectedIssue,
      undefined,
    );
    this.serviceRequestService.getIssueDetails(selectedIssue);
  }

  onSelectIssueDetails(issueDetails: IssueDetails) {
    this.serviceRequestService.setModalIssueAndDetails(
      this.serviceRequestService.modalRelatedParams.issue,
      issueDetails,
    );
  }

  async dismissModal(needValueReset: boolean = false) {
    await this.modalController.dismiss(needValueReset);
  }
}
